// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Ze9W1","list":"styles_list__3FYHB"};